import { BaseMapComponent } from '@map-sdk/components/map'
import { BaseMapTitleLayer } from '@map-sdk/components/mapTitleLayer'
import { BaseDrawshipcount } from '@map-sdk/components/drawshipcount'

export default [BaseMapComponent, BaseMapTitleLayer, BaseDrawshipcount]
